import React from 'react';
import { useDataGrid } from '..';

const DataGridTableHeadRowsSelect = () => {
  const {
    isSelectAllChecked,
    isSelectAllIndeterminate,
    toggleAllRowsSelection,
  } = useDataGrid();

  return (
    <th className="table-cell-center w-0">
      <label
        htmlFor="select-all-rows"
        className="sr-only"
        aria-label="Select All"
      >
        Select All
      </label>
      <input
        type="checkbox"
        id="select-all-rows"
        className="checkbox checkbox-sm cursor-pointer"
        checked={isSelectAllChecked}
        ref={(input) => {
          if (input) {
            input.indeterminate = isSelectAllIndeterminate;
          }
        }}
        onChange={(e) => {
          const { checked } = e.target; // Correctly capture the checked value
          toggleAllRowsSelection(checked);
        }}
      />
    </th>
  );
};

export { DataGridTableHeadRowsSelect };
